import React from 'react';
import { Truck, Navigation, Package, ShieldCheck } from 'lucide-react';

const Logistics = () => {
  return (
    <div className="pt-24 bg-gray-950 min-h-screen text-left">
      <section className="py-20 bg-gradient-to-b from-gray-950 via-slate-900 to-gray-950 border-b border-gray-800">
        <div className="container mx-auto px-6 max-w-4xl text-center">
          <div className="inline-flex items-center space-x-2 bg-orange-500/10 border border-orange-500/20 rounded-full px-4 py-1.5 mb-4">
            <Truck className="w-4 h-4 text-orange-400" />
            <span className="text-orange-400 text-sm font-semibold uppercase tracking-wider">
              Logistics & Supply Chain Solutions
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight">
            Intelligent Fleet & <span className="bg-gradient-to-r from-orange-400 via-amber-400 to-cyan-400 bg-clip-text text-transparent">Supply Chain Software</span>
          </h1>
          <p className="text-gray-300 text-base md:text-lg leading-relaxed">
            Real-time GPS tracking, automated dispatch routing, warehouse inventory management, and freight optimization tools.
          </p>
        </div>
      </section>

      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-950 border border-gray-800 rounded-3xl p-8">
              <Navigation className="w-10 h-10 text-cyan-400 mb-6" />
              <h3 className="text-xl font-bold text-white mb-3">Live Fleet GPS Tracking</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">Real-time vehicle Telematics, driver behavior analytics, and geofencing alerts.</p>
            </div>
            <div className="bg-gray-950 border border-gray-800 rounded-3xl p-8">
              <Package className="w-10 h-10 text-orange-400 mb-6" />
              <h3 className="text-xl font-bold text-white mb-3">Freight & Dispatch Portal</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">Automated load matching, electronic proof of delivery (ePOD), and route optimization algorithms.</p>
            </div>
            <div className="bg-gray-950 border border-gray-800 rounded-3xl p-8">
              <ShieldCheck className="w-10 h-10 text-amber-400 mb-6" />
              <h3 className="text-xl font-bold text-white mb-3">Warehouse WMS Systems</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">Barcode scanning, stock bin tracking, order picking workflow, and carrier API integration.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Logistics;
